import { css } from '@emotion/css';

export const inputStyles = css`
  padding-inline-start: 0;
  &:hover {
    border-color: var(--interactive-border);
  }
`;
